import { formatDate } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatDate'
})

export class FormatDatePipe implements PipeTransform {
  transform(value: Date | string | null): string {
    if (!value) return '';
    return formatDate(value, 'dd/MM/yyyy', 'en-US');
  }
}